import { BaseService } from './base';

export interface OrganizationDTO {
    latitude: number;
    longitude: number;
    id: string;
    name: string;
}

export class OrganizationService extends BaseService {
    dto: OrganizationDTO;

    public cache?: Promise<OrganizationDTO[]>;

    constructor() {
        super();
        this.dto = {} as OrganizationDTO;
        this.dto.latitude = 41.96593;
        this.dto.longitude = -91.67687;
    }

    public async init() {
        return new Promise((resolve, _reject) => {
            const request = this.getSettings();
            request.then((data) => {
                if (data.parsedBody) {
                    const dto = data.parsedBody;
                    if (dto.latitude && dto.longitude) {
                        this.dto = dto;
                    }
                    resolve('Loaded');
                }
            });
        });
    }

    private async getSettings() {
        const response = await this.get<OrganizationDTO>(this.url + '/api/' + this.orgid);
        return response;
    }

    public cachedOrgList(): Promise<OrganizationDTO[]> {
        // Check if the data for the given id is already cached
        if (this.cache) {
            return this.cache;
        }

        // If not cached, fetch the data and store the promise in the cache
        const promise = this.fetchOrgList();
        this.cache = promise;
        return promise;
    }

    private fetchOrgList(): Promise<OrganizationDTO[]> {
        const url = this.url + '/api/organization/list';
        return fetch(url, {
            method: 'GET',
            headers: this.headers(),
        }).then((response) => {
            return response.json();
        });
    }

    public async save(org: OrganizationDTO) {
        if (org.id != undefined) {
            return await this.put<OrganizationDTO>(this.url + '/api/organization', org);
        } else {
            return await this.put<OrganizationDTO>(this.url + '/api/organization', org);
        }
    }
}
